import { Button, Checkbox, DatePicker, Form, Input, Modal } from "antd";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { axiosErrorMessages, createSoftware } from "../../../API/api";
import axios, { AxiosError } from "axios";
const { RangePicker } = DatePicker;
interface AddEditCategoryType {
  handleClose: (data: boolean) => void;
}
const AddNewSoftware: React.FC<AddEditCategoryType> = ({ handleClose }) => {
  const [addnewSoftwareForm] = Form.useForm();
  const [isOs, setIsOs] = useState<boolean>(false);

  const rangeConfig = {
    rules: [
      {
        type: "array" as const,
        required: true,
        message: "Please select Validity",
      },
    ],
  };
  type FieldType = {
    isSoftware?: boolean;
    softwareName?: string;
    companyName?: string;
    version?: string;
    paidFree?: string;
    startDate?: any;
    endDate?: string;
  };
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const handleCloseAddEditPopup = () => {
    setIsOpen(false);
    handleClose(true);
  };
  const onSaveStatusHandler = (formData: any) => {
    const saveData = {
      softwareName: formData.softwareName.trim(),
      companyName: formData.companyName.trim(),
      version: formData.version.trim(),
      isOS: formData.isSoftware,
      isPais:true,
      // isPaid: formData.paidFree === "Paid" ? true : false,
      startDate: formData["range-picker"][0]
        ? formData["range-picker"][0].toISOString()
        : new Date(),
      expiryDate: formData["range-picker"][1]
        ? formData["range-picker"][1].toISOString()
        : new Date(),
    };
    createSoftware(saveData)
      .then((response: any) => {
        enqueueSnackbar("Added Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        handleClose(true);
      })
      .catch((error: any) => {
        if(error.response.data.errors.Software[0])
        enqueueSnackbar(error.response.data.errors.Software[0],{ variant: 'error', anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },})
        else{
          let errorMsg;
          if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            errorMsg = axiosErrorMessages(axiosError);
          } else {
            errorMsg = error.message;
          }
          enqueueSnackbar(errorMsg, {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
      
    
      });
  };
  const isCheckedIsOs = (e: any) => {
    const isSoftwareFieldValue = addnewSoftwareForm.getFieldValue('isSoftware');
    addnewSoftwareForm.resetFields(); // This will reset all fields including the checkbox
    addnewSoftwareForm.setFieldsValue({ isSoftware: isSoftwareFieldValue }); // Set the checkbox back to its original value
    setIsOs(e.target.checked);
  };
  return (
    <div>
      <Modal
        footer={null}
        title="Add Software"
        open={isOpen}
        onCancel={handleCloseAddEditPopup}
        maskClosable={false}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          onFinish={onSaveStatusHandler}
          autoComplete="off"
          form={addnewSoftwareForm}
          initialValues={{ isSoftware: false }}
        >
          <Form.Item<FieldType>
            label="OS"
            name="isSoftware"
            valuePropName="checked"
          >
            <Checkbox onChange={isCheckedIsOs}></Checkbox>
          </Form.Item>
          <Form.Item<FieldType>
            label={isOs ? "OS Name" : "Software Name"}
            name="softwareName"
            rules={[{ required: true, message: "Enter Name" }]}
          >
            <Input maxLength={50} />
          </Form.Item>

          <Form.Item<FieldType>
            label="Company"
            name="companyName"
            rules={[{ required: true, message: "Enter Company Name" }]}
          >
            <Input maxLength={50} />
          </Form.Item>
          <Form.Item<FieldType>
            label="Version"
            name="version"
            rules={[{ required: true, message: "Enter Version" }]}
          >
            <Input maxLength={50} />
          </Form.Item>

          <Form.Item name="range-picker" label="Validity" {...rangeConfig}>
            <RangePicker />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button className="pm-btn" type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddNewSoftware;
